import "@fontsource/roboto/100.css";
import "@fontsource/roboto/200.css";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/600.css";
import "@fontsource/roboto/700.css";
import "@fontsource/roboto/800.css";
import "@fontsource/roboto/900.css";
import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import relativeTime from "dayjs/plugin/relativeTime";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "@/App";
import "@/App/styles/globals.css";
import "@/App/styles/theme.css";
import { configureAmplify } from "@/shared/auth";
import "@/shared/foundation/styles/colors.css";
import "@/shared/foundation/styles/spacing.css";
import "@/shared/foundation/styles/typography.css";
import "@/shared/foundation/styles/utilities.css";

import { configureMonaco } from "./App/configureMonaco";

await configureAmplify();

// Setup Monaco code editor but doesn't load it until it's needed
configureMonaco();

dayjs.extend(duration);
dayjs.extend(relativeTime);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
